const DocumentList = async () =>
    import('../../pages/documents/View').then((module) => ({
        Component: module.LogisticManagementDocumentsView,
    }));

const getDocumentRoutes = () => {
    return [
        {
            path: '/documents/',
            lazy: DocumentList,
        },
    ];
};

export { getDocumentRoutes };
